import _ from '@/utils/lodash-optimized'

import { SystemRoles } from '../../../../../lib/Codes'
import FormattedPhone from '../../../../shared/Phone/FormattedPhone'

export const CareTeamExtensions = [
  {
    label: 'Patient Lead',
    value: 'pcp'
  },
  {
    label: 'Level 4',
    value: 'l4'
  },
  {
    label: 'Level 5',
    value: 'l5'
  }
]

const sortValues = val => {
  if (val === 'pcp') {
    return 5
  }
  if (val === 'l4') {
    return 2
  }
  if (val === 'l5') {
    return 1
  }
  return 4
}

export const tableDefinition = [
  {
    title: 'Name',
    displayFn: v => {
        const first = _.capitalize(v?.firstName)
        const last = _.capitalize(v?.lastName)
        const suffix = v?.honorifics
      const parts = [ [ first, last ].join(' ') ]
      if (suffix?.length) {
        parts.push(suffix)
      }
      const name = parts.join(', ')
      return ((v.active && name) || `${name} (inactive)`)
    }
  },
  {
    title: 'Role',
    displayFn: v =>
      (SystemRoles.filter(r => v.role === r.code)[0]
        ? SystemRoles.filter(r => v.role === r.code)[0].label
        : '')
  },
  {
    title: 'Phone',
    displayFn: ({ phone }) => <FormattedPhone number={phone} />
  },
  {
    title: 'Email',
    displayFn: v => v.email
  },
  {
    title: 'Alert Level',
    displayFn: v =>
      (CareTeamExtensions.filter(e => v.alertLevel === e.value)[0]
        ? CareTeamExtensions.filter(e => v.alertLevel === e.value)[0].label
        : 'Level 2'),
    sortFn: (a, b) => {
      const aVal = sortValues(a.alertLevel)
      const bVal = sortValues(b.alertLevel)
      if (aVal > bVal) {
        return -1
      }

      if (aVal < bVal) {
        return 1
      }

      return 0
    }
  }
]
